import HoraireInformations from "./HoraireInformations.jsx";

export default HoraireInformations;
